export default __webpack_public_path__ + "static/media/ded-tools-dropbox.0d28fa6f.svg";